<template>
  <RegisterForm
    :title="title"
    :desc="desc"
    :nextButtonLabel="nextButtonLabel"
    :nextButtonOnClick="nextButtonOnClick"
    :backButtonOnClick="backButtonOnClick"
    :errorText="errorText"
    horizontalPadding="pl-0 pr-10"
    verticalPadding="py-0"
    ><slot
  /></RegisterForm>
</template>

<script>
import RegisterForm from './RegisterForm.vue';
export default {
  components: { RegisterForm },
  name: 'IbtRegisterForm',
  props: {
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
    nextButtonLabel: { type: String, default: 'common.button.next' },
    nextButtonOnClick: { type: [Function, null], default: null },
    backButtonOnClick: { type: [Function, null], default: null },
    errorText: { type: String, default: '' }
  }
};
</script>
